import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";

export default function AdminList() {

  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all admins
  useEffect(() => {
    axios.get("https://apnaqwebx-mern.onrender.com/api/auth/all")
      .then(res => setAdmins(res.data), setLoading(false))
      .catch(err => console.log(err), setLoading(false));
  }, []);

  // Delete admin
  const deleteAdmin = async (id) => {
    if (!window.confirm("Are you sure you want to delete this admin?")) return;

    try {
      await axios.delete(`https://apnaqwebx-mern.onrender.com/api/auth/${id}`);
      setAdmins(admins.filter(admin => admin._id !== id));
    } catch (error) {
      alert("Error deleting admin");
    }
  };

  return (
    <div className="p-6 md:pt-32 pt-44">


      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-[#855109]">Admin List</h1>

        <Link
          to="/admin/add-admin"
          className="px-5 py-2 bg-[#855109] text-white rounded-lg shadow hover:bg-[#6d4108] transition font-semibold"
        >
          + Add New Admin
        </Link>
      </div>

       {/* LOADING */}
              {loading && (
                // <p className="text-center mt-10 text-[#855109]">Our AdminList Loading...</p>
                <Preloader />
              )}


      <div className="bg-white shadow-lg rounded-xl border border-[#e7d5c2] p-6">

        {/* Table Header */}
        <table className="w-full">
          <thead>
            <tr className="bg-[#f0e4d4] text-[#895712] uppercase text-sm font-bold">
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {admins.map(admin => (
              <tr
                key={admin._id}
                className="border-b hover:bg-[#f8f3ec] transition"
              >
                <td className="p-3 font-semibold">{admin.name ?? "—"}</td>
                <td className="p-3">{admin.email}</td>

                <td className="p-3 text-center">
                  <button
                    onClick={() => deleteAdmin(admin._id)}
                    className="px-4 py-1 bg-red-600 text-white rounded-md shadow hover:bg-red-700 transition"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

    </div>
  );
}
